import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PublicLayout from "@/components/layout/PublicLayout";
import SectionEyebrow from "@/components/common/SectionEyebrow";
import { publicApi } from "@/lib/api";

export default function Legal() {
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\/+|\/+$/g, "");
  const [doc, setDoc] = useState(null);
  useEffect(() => {
    publicApi.legal(slug).then(setDoc).catch(() => setDoc({ title: "Not found", body: "" }));
  }, [slug]);

  if (!doc) return <PublicLayout />;
  return (
    <PublicLayout title={doc.title}>
      <section className="bg-[#F8F6F1] py-24 md:py-32">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <SectionEyebrow>Legal</SectionEyebrow>
          <h1 className="font-serif text-4xl md:text-5xl tracking-tight">{doc.title}</h1>
          <div className="mt-4 text-xs text-[#9CA3AF] bsca-eyebrow">Last updated: {doc.last_updated} · Status: {doc.status}</div>
          <article className="mt-10 text-[#1f2937] leading-relaxed whitespace-pre-line">
            {doc.body}
          </article>
        </div>
      </section>
    </PublicLayout>
  );
}
